// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2kwcg","topBottomGutter":"Layout_topBottomGutter__mG6AU"};